import type { ICustomerLeadProductDetailsTabFormValues } from 'src/components/customers/CustomerLeadTypes';
import {
  formCustomerProductLeadSpecificationEditValidationSchema,
  toFormCustomerProductLeadSpecificationInitialValues,
} from 'src/components/customers/CustomerLeadValidation';
import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';
import type { IProductSpecificationFieldReference } from 'src/types/reference/IProductSpecificationReference';

export const customerLeadProductProductSpecificationsValidationSchema = (
  fields: IProductSpecificationFieldReference[]
) => formCustomerProductLeadSpecificationEditValidationSchema(fields);

export const customerLeadProductProductSpecificationsInitialValues = (
  fields: IProductSpecificationFieldReference[],
  customerLeadProduct?: ICustomerLeadProduct
): ICustomerLeadProductDetailsTabFormValues => ({
  ...toFormCustomerProductLeadSpecificationInitialValues(fields, customerLeadProduct),
});
